module.exports = __webpack_public_path__ + "static/img/female-bg-id.bf001024.png";